<template>
  <el-dialog
    width="40%"
    ref="dialog"
    :visible.sync="visible"
    @closed="handleClosed"
    custom-class="el-dialog--tiny"
  >
    <div slot="title">{{ $t('c.dialog.titleChangeEmails') }}</div>

    <div>
      <p>{{ $t('c.dialog.messageChangeEmails1') }}</p>

      <v-input-tag
        v-model="localEmails"
        :placeholder="$t('c.dialog.placeholderEnterEmail')"
        :validate="validateEmail"
      />
    </div>

    <v-row slot="footer" justify="between">
      <v-button theme="primary" view="transparent" @click="close">{{ $t('c.dialog.buttonCancel') }}</v-button>
      <v-button
        theme="primary"
        :disabled="loading || !canSaveEmails"
        @click="saveChanges"
      >{{ $t('c.dialog.buttonSave') }}</v-button>
    </v-row>
  </el-dialog>
</template>

<script>
import VInputTag from '@/components/common/VInputTag.vue'
import VRow from '@/components/common/VRow.vue'
import * as types from '@/store/types'
import visibleMixin from '@/mixins/visible@deprecated'
import { equalsArray, validateEmail } from '@/utils/common'

export default {
  name: 'VEmailsDialogChange',

  components: {
    VInputTag,
    VRow
  },

  mixins: [visibleMixin],

  props: {
    emails: {
      type: Array,
      required: true
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      localEmails: this.emails.map(item => item.email)
    }
  },

  computed: {
    canSaveEmails() {
      const emailsValues = this.emails.map(item => item.email)
      return !equalsArray(this.localEmails, emailsValues)
    }
  },

  watch: {
    emails(values) {
      this.localEmails = values.map(item => item.email)
    }
  },

  methods: {
    validateEmail,

    handleClosed() {
      this.localEmails = this.emails.map(item => item.email)
    },

    saveChanges() {
      // // функция поиска элементов list, которых нет в pattern
      // const difference = (list, pattern) => list.reduce((result, email) => {
      //   if (!pattern.includes(email)) {
      //     result.push({
      //       value: email,
      //       type: 'email'
      //     })
      //   }

      //   return result
      // }, [])

      const { localEmails, emails } = this

      const added = localEmails.reduce((result, email) => {
        const findIndex = emails.findIndex(tool => tool.value === email)

        if (findIndex === -1) {
          result.push(email)
        }

        return result
      }, [])

      const removed = emails.reduce((result, email) => {
        const { id, value } = email

        if (!localEmails.includes(value)) {
          result.push(id)
        }

        return result
      }, [])

      this.$store
        .dispatch(types.SAVE_NOTIFICATION_TOOLS, {
          added,
          removed
        })
        .then(() => this.close())
    }
  }
}
</script>
